import NFButton from './NFButton';

export default NFButton;



// WEBPACK FOOTER //
// ./src/components/primitives/NFButton/index.jsx